import React, {useRef, useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import {IProps, IState} from './types';
import * as S from './styles';
import SelectDownIcon from 'common/icons/selectDownIcon';
import SelectUpIcon from 'common/icons/selectUpIcon';
import CheckBoxIcon from 'common/icons/checkBoxIcon';
import UncheckBoxIcon from 'common/icons/uncheckBoxIcon';
import Loading from 'components/InnerLoader';
//import C from '@assets/themes/colors';
//import { noSpecialCharacters } from '@utils/userUtils';
import { cloneDeep } from 'lodash';
import TextToolTip from 'components/TextToolTip';
//import { findFontByNameOrId } from '@utils/fonts';
//import { IDSConfig } from '@state/dsconfig/types';

const ComboBox:React.FC<IProps> = (props) => {  
  const [optionsMaxLenght, setOptionsMaxLenght] = useState<number|undefined>(props.pageSize);
  const [value, setValue] = useState<IState['value']>('');
  const [typing, setTyping] = useState(false);
  const [customValue, setCustomValue] = useState("");
  const [errorRepeated, setErrorRepeated] = useState(false);

  const filterForMaxLenght = (options: string[]) => {
    options = options.map((option: string) => option.replace(/\"/g,"''"));
    options = options.map((option: string) => option.replace(/\'/g,"`"));
    const newOptions = cloneDeep(options);
    if (newOptions && optionsMaxLenght && optionsMaxLenght<newOptions.length) {
      return newOptions.splice(0,optionsMaxLenght);
    }
    return options; 
  }

  const [optionsFiltered, setOptionsFiltered] =  useState<string[]>(filterForMaxLenght(props.options));  

  useEffect(() => {
    setValue(props.value);
  }, [props.value])

  useEffect(() => {
    setOptionsFiltered(filterForMaxLenght(props.options));    
  }, [props.options]);

  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const [open, setOpen] = useState(false);
  const [focused, setFocused] = useState(false);
  const [currentValue, setCurrentValue] = useState(props.placeholder);

  const handleOpen = () => {
    if (props.disabled === false)
      setOpen(!open);
  }

  const handleSelectOption = (index:number) => {
    if (optionsFiltered.length > 0) {
      setCurrentValue(optionsFiltered[index]);
      setValue(optionsFiltered[index]);
      props.chooseOption(props.id, optionsFiltered[index]);
      setTyping(false);
      setOptionsFiltered(filterForMaxLenght(props.options));
      if (!(props.multiSelect && props.multiSelect === true))
      setOpen(false);
    }
  }

  const renderCheckboxes = (option: string) => {
    if (props.values && props.values.length > 0) {
      var valueIndex = props.values.findIndex((value: string) => (value === option));
      if (valueIndex >= 0) return <CheckBoxIcon />
      else return <UncheckBoxIcon/>
    } else return <UncheckBoxIcon/>
  }

  const handlePlaceholder = () => {
    let newPlaceholder =
      props.multiSelect === true && props.values && props.values.length > 0 && !typing ?
        props.values.length === 1 ? props.values[0] : `${props.values.length} ${props.multiSelectPlaceholder}` 
      :
        props.placeholder;
    return newPlaceholder;
  }

  const handleValue = () => {
    let newValue = props.multiSelect === true ? 
      props.values && props.values.length === 1 ? props.values[0] : '' 
    : 
      props.value;
    return typing ? value : newValue?.replace(/\`/g,"'");
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target){
      setValue(e.target.value);
      props.chooseOption(props.id, e.target.value);
    } 
  }

  const handleFocus = () => {
    setFocused(true);
  }

  const handleBlur = () => {
    setFocused(false);
  }

  useEffect(() => {
    if (focused && !props.disabled) {
      setTyping(true);
      setOpen(true);
    } else {
      setTyping(false);
      if (!(props.multiSelect && props.multiSelect === true || props.addNewOption))
      setOpen(false);
    }
  }, [focused]);

  useEffect(() => {
    if (!open) {
      setTyping(false);
      setValue(props.value);
      setOptionsFiltered(filterForMaxLenght(props.options));
    }
    if (props.setIsOpen) props.setIsOpen(open);
  }, [open]);

  const getFilteredOptions = () => {
    if (value === "") {
      return props.options;
    } else if (value && typing === true) {
      try {
        const PATTERN = new RegExp(value, "i");
        return props.options.filter((str: string) => { 
          return PATTERN.test(str); 
        });
      } catch(e) {
        return [];
      }
    }
    return props.options;
  }

  useEffect(() => {
    if(props.pageSize) setOptionsMaxLenght(props.pageSize);
    setOptionsFiltered(filterForMaxLenght(getFilteredOptions()!));
  }, [value]);

  const scrollEnd = (e: React.UIEvent<HTMLElement>): boolean => {
    const optionsContainer = (e.target as HTMLDivElement);
    return (optionsContainer.offsetHeight + optionsContainer.scrollTop >= optionsContainer.scrollHeight)
  }

  useEffect(() => {
    setOptionsFiltered(filterForMaxLenght(getFilteredOptions()!));
  }, [optionsMaxLenght]);

  const optionsOnScroll = (e: React.UIEvent<HTMLElement>) => {
    if (props.pageSize) {
      if (scrollEnd(e)) {
        setOptionsMaxLenght(optionsMaxLenght! + props.pageSize);
      }
    }
  }

  const customHandleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCustomValue(e.target.value);
    const repeatedIndex = props.options.findIndex((item) => item === e.target.value.trim());
    if (repeatedIndex >= 0) setErrorRepeated(true);
    else setErrorRepeated(false);
  }

  const customHandleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const newValue = customValue.trim();
    if (e.key === "Enter" && newValue !== "") {
      if (!errorRepeated && props.addNewOption)
      props.addNewOption(props.id, newValue);
      setCustomValue("");
    } 
    //else {
    //  noSpecialCharacters(e);
    //}
  }

  const formatString = (stringValue: string) => {return  stringValue.replace(/\`/g,"'")};

  const getFontFamily = (font: string | undefined) => {
    let oemFont = font;
    /*if (font) {
      const resultFont = findFontByNameOrId(dsConfig.OEMs, "name", font);
      if (resultFont) oemFont = `font-${resultFont.id}`;
    }*/
    return oemFont;
  }

  return (
    <S.Root 
      ref={wrapperRef} 
      style={props.containerStyle}
      light={props.light}
    >
      { 
        (props.title || props.required === true) &&
        <S.TopContainer>
          {
            props.title &&
            <S.TitleLabel style={props.titleStyle} >
              {props.title}
            </S.TitleLabel>
          }
          {
            props.required === true &&
            <S.RequiredLabel>
              Required
            </S.RequiredLabel>
          }
        </S.TopContainer>
      }
      <TextToolTip  tip={handleValue()} >      
      <S.BoxContainer
        style={props.inputContainerStyle}
        light={props.light}
        shadow={props.shadow}
      >
     
        <S.SelectContainer 
          id={props.id}
          tabIndex={1}
          autoComplete={"off"}
          style={props.style}
          //fontFamily={getFontFamily(props.value)}
          placeholder={handlePlaceholder()}
          value={handleValue()}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          textColor={'black'}
          disabled={props.disabled}
          placeholderColor={props.multiSelect === true && (props.values && props.values.length > 0) && !typing ? 'black' : 'lightgray'}
        />        
        <S.ArrowsContainer onClick={handleOpen} >
          {
            !props.disabled && 
            <>
              {
                open ?
                <SelectUpIcon light={props.light} />
                :
                <SelectDownIcon light={props.light} />
              }
            </>
          }
        </S.ArrowsContainer>
      </S.BoxContainer>
      </TextToolTip>
      <S.OptionsContainer 
        show={open ? 'flex' : 'none'} 
        position={props.position}
        required={props.required}
        light={props.light}
        topContent={(props.title && props.title !== "") || props.required === true}
        style={props.optionContainerStyle}
        onScroll={optionsOnScroll}
      >
        {
          props.isLoading === true &&
          <Loading 
            backgroundColor='black'
          />
        }
        {
          optionsFiltered.map((option:string, index:number) => {
            if (props.multiSelect && props.multiSelect === true)
            return (
              <S.OptionMultiselect 
                key={index} 
                style={props.optionStyle} 
                fontFamily={getFontFamily(option)}
                onClick={() => handleSelectOption(index)}
              >
                <S.CheckBoxesContainer>
                  {renderCheckboxes(option)}
                </S.CheckBoxesContainer>
                {formatString(option)} 
              </S.OptionMultiselect>
            )
            else
            return (
              <S.Option key={index} style={props.optionStyle} 
                //backgroundColor={currentValue === option ? 'gray': 'white'}
                selected={currentValue === option}
                fontFamily={getFontFamily(option)}
                onMouseDown={() => handleSelectOption(index)}
              >
                {formatString(option)} 
              </S.Option>
            )
          })
        }
        {
          (typing && optionsFiltered.length === 0 && value) &&
          <S.NoResultsFound>
            No results found
          </S.NoResultsFound>
        }
        {
          props.addNewOption && 
          <S.TextContainer
            id={`custom-option-input-${props.id}`}
            placeholder={`+Add New ${props.title}`}
            value={customValue}
            onChange={customHandleChange}
            onKeyPress={customHandleKeyPress}
            //onPaste={noSpecialCharacters}
            textColor={customValue === "" ? 'darkgray' : 'black'}
          />
        }
      </S.OptionsContainer>
      {
        props.tipLabel &&
        <S.TipLabel textColor={props.tipLabelColor ?? "#8891a0"} >
          {props.tipLabel}
        </S.TipLabel>
      }
    </S.Root>
  );
}

export default ComboBox;